module.exports = __webpack_public_path__ + "static/media/logo.dcd37274.png";